import axios from "axios";
import { PmInterface } from "../../common/interfaces/common";
import { get200ErrorMsg, getErrorMsg } from "../../common/utils/request";
import {
	SaveInlineEditingData,
	SaveInlineEditingResponse,
} from "../interfaces/http";

declare var pm: PmInterface;

export const saveInlineEditing = async (
	data: SaveInlineEditingData,
): Promise<SaveInlineEditingResponse> => {
	try {
		const formData = new FormData();

		for (const key in data) {
			if (data.hasOwnProperty(key)) {
				const value = data[key];
				formData.append(key, value);
			}
		}

		const axiosResponse = await axios.post(pm.ajaxurl, formData);

		if (!axiosResponse.data || !axiosResponse.data.success) {
			return {
				success: false,
				message: get200ErrorMsg(axiosResponse),
			};
		}

		return {
			success: true,
			message: "Data has been edited successfully.",
			data: axiosResponse.data.data,
		};
	} catch (response: any) {
		return {
			success: false,
			message: getErrorMsg(response),
		};
	}
};
